import React from 'react';
import { MUTED, HAIRLINE } from './tokens';
import { useSoft, SOFT } from './SurfaceStyleContext';

/** The 52×28 square switch: black track + white knob when on, white track + black knob when off. */
export function SquareSwitch({ checked, onChange, disabled = false, label, small = false }) {
  const w = small ? 48 : 52; const h = small ? 26 : 28; const k = small ? 18 : 20;
  const soft = useSoft();
  if (soft) {
    // Soft: the 34×20 pill switch of the host kit.
    return (
      <button
        type="button"
        role="switch"
        aria-checked={!!checked}
        aria-label={label}
        disabled={disabled}
        onClick={() => onChange?.(!checked)}
        className="relative inline-block flex-none rounded-full transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
        style={{ width: 34, height: 20, background: checked ? '#000' : '#D1D5DB', padding: 0, border: 'none' }}
      >
        <span className="absolute rounded-full bg-white transition-all duration-200" style={{ top: 3, left: checked ? 17 : 3, width: 14, height: 14 }} />
      </button>
    );
  }
  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange?.(!checked)}
      className="relative inline-block flex-none border-2 border-black transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
      style={{ width: w, height: h, background: checked ? '#000' : '#fff', padding: 0 }}
    >
      <span className="absolute" style={{ top: 2, [checked ? 'right' : 'left']: 2, width: k, height: k, background: checked ? '#fff' : '#000' }} />
    </button>
  );
}

/** Label + description on the left, square switch on the right. `boxed` wraps it in its own border (mobile cards). */
export default function SwitchRow({ label, desc, checked, onChange, disabled = false, boxed = false, last = false, dense = false, testId }) {
  const soft = useSoft();
  return (
    <div
      className={`flex items-center gap-4 ${boxed && !soft ? 'border-2 border-black' : ''}`}
      style={soft
        ? { padding: boxed ? '12px 16px' : '10px 0', borderRadius: boxed ? 18 : 0, background: boxed ? SOFT.canvas : undefined, borderBottom: !boxed && !last ? `2px solid ${SOFT.chip}` : undefined }
        : { padding: boxed || dense ? '11px 12px' : '14px 16px', borderBottom: !boxed && !last ? `2px solid ${HAIRLINE}` : undefined }}
      data-testid={testId}
    >
      <div className="min-w-0 flex-1">
        <div className="font-mono font-bold" style={{ fontSize: dense ? 12 : 13 }}>{label}</div>
        {desc && <div className="font-mono" style={{ fontSize: dense ? 10 : 11, color: MUTED, marginTop: 3, lineHeight: 1.5 }}>{desc}</div>}
      </div>
      <SquareSwitch checked={checked} onChange={onChange} disabled={disabled} label={label} small={dense} />
    </div>
  );
}
